import React from "react";
import { Modal, Box } from "@mui/material";

interface ConfirmationModalProp {
  open: boolean;
  handleClose: () => void;
  yesBtnTxt: string;
  noBtnTxt: string;
  image: string;
  onClick: () => void;
}

const CancelConfirmationModal = ({
  open,
  handleClose,
  yesBtnTxt,
  noBtnTxt,
  image,
  onClick,
}: ConfirmationModalProp) => {
  return (
    <Modal
      open={open}
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      onClose={(event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason !== "backdropClick") handleClose();
      }}
      slotProps={{
        backdrop: {
          sx: { backdropFilter: "blur(10px)" }, // Apply blur effect
        },
      }}
    >
      <Box className="success-popup confirmation_popup" sx={{ width: 400 }}>
        <div className="popup-wrap">
          <div className="popup-head">
            <img className="popup-image" src={image} alt=".." />
            <h2 className="modal-title">Cancel</h2>
            <p className="modal-description">
              Are you sure you want to exit? Any saved data will remain saved.
            </p>
          </div>

          <div className="btn_wraps">
            <button
              type="button"
              className="primary_btn"
              onClick={() => {
                onClick();
              }}
            >
              {yesBtnTxt}
            </button>
            <button
              type="button"
              className="cancel_btn"
              onClick={() => {
                handleClose();
              }}
            >
              {noBtnTxt}
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default CancelConfirmationModal;
